import { h } from 'preact'

interface Props {
  tabs: Array<string>,
  activeTab: number,
  onCallback: (tab: number) => void
}

const GroupEditTabs = (props: Props) => (
  <div className='group-edit_container--tabs'>
    {
      props.tabs.map((tab, index) => (
        <span
          className={`group-edit_container--tab ${props.activeTab === index ? 'active-tab' : ''}`}
          onClick={() => props.onCallback(index)}>
          { tab }
        </span>
      ))
    }
  </div>
)

export default GroupEditTabs
